import React from "react";
import { Switch, Route } from "react-router-dom";
import PlanHandle from "../containers/planHandleContainer"
import New from "../containers/newContainer"
import PlanHandleStep from "../containers/planHandleStepContainer"

function RouterPlanHandle() {
    return (
        <Route path="/PlanHandle">
            <Switch>
                <Route path="/PlanHandle" exact>
                    <div style={{ "textAlign": "center", "fontSize": "35px", "fontWeight": "800" }}>
                        Wecome Area PlanHandle
                    </div>
                </Route>
                <Route path="/Home" exact>
                    <div style={{ "textAlign": "center", "fontSize": "35px", "fontWeight": "800" }}>
                        Wecome Area PlanHandle
                    </div>
                </Route>
                <Route path="/PlanHandle/Main/:id" exact>
                    <PlanHandle/>
                </Route>
                <Route path="/PlanHandle/New/:id" exact>
                    <New/>
                </Route>
                <Route path="/PlanHandle/New/:id/Clone/:planID" exact>
                    <New/>
                </Route>
                <Route path="/PlanHandle/New/:id/Edit/:planID" exact>
                    <New/>
                </Route>
                <Route path="/PlanHandle/Edit/:id/:planID" exact>
                    <New/>
                </Route>
                <Route path="/PlanHandle/PlanHandleStep/:id" exact>
                    <PlanHandleStep/>
                </Route>
            </Switch>
        </Route>
    );
}
export default RouterPlanHandle;
